import { deleteCookie, getTokenFromCookies, setTokenCookie, url } from "../utils/configData";

// const url = `http://192.168.0.103:8000/api`;
const convertPhoneNumber = (phone) => {
  // Function to convert phone number to digits only
  const digitsOnly = phone.replace(/\D/g, "");
  return digitsOnly;
};

// Function to fetch login data
const fetchLogin = async ({ emailOrPhone, password, keep, code, methodF2A }) => {
  const endpoint = "/users/sign-in";
  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  let body = {
    password: password,
    keep: keep,
    code: code,
    method: methodF2A,
  };

  if (isValidEmail(emailOrPhone)) {
    body.email = emailOrPhone.toLowerCase();
  } else {
    body.phone = emailOrPhone;
  }

  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.ok) {
      const data = await response.json();
      if (data.authtoken) {
        setTokenCookie(data.authtoken, 7);
      }
      return { success: true, dataUser: { ...data, isAuth: true } };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        message: errorData.message || "Аутентифікація не вдалася.",
      };
    }
  } catch (error) {
    console.error("Під час процесу входу сталася помилка:", error);
    return { success: false, message: "Сталася непередбачена помилка." };
  }
};

const fetch2fa = async ({ methodF2A, emailOrPhone, password }) => {
  const endpoint = `/users/sign-in/${methodF2A}/code`;
  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  let body = {
    password: password,
  }
  console.log(emailOrPhone);
  if (isValidEmail(emailOrPhone)) {
    body.email = emailOrPhone.toLowerCase();
  } else {
    body.phone = emailOrPhone;
  }

  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        message: errorData.message || "Authentication failed.",
      };
    }
  } catch (error) {
    console.error("An error occurred during the login process:", error);
    return { success: false, message: "An unexpected error occurred." };
  }
};

// Function to fetch create account data
const fetchCreate = async ({
  fname,
  mname,
  lname,
  code,
  codePhone,
  email,
  phone,
  password,
  confirmPassword,
}) => {
  const endpoint = "/users/create";
  const body = {
    email: email.toLowerCase(),
    email_code: code,
    fname: fname,
    mname: mname,
    lname: lname,
    password: password,
    phone: `+${convertPhoneNumber(phone)}`,
    phone_code: codePhone,
    repeated_password: confirmPassword,
  };

  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (response.ok) {
      const data = await response.json();
      // Зберігаємо токен у локальному сховищі
      if (data.authtoken) {
        setTokenCookie(data.authtoken, 7);
      }
      return {
        success: true,
        userData: {
          ...data,
          fname: fname,
          mname: mname,
          lname: lname,
          phone: phone,
          email: email.toLowerCase(),
          completed: false,
          // isAuth: true,
        },
        message: "Акаунт успішно створено.",
      };
    } else {
      const errorData = await response.json();
      console.log(errorData, response.status);
      return {
        success: false,
        status: response.status,
        error: errorData.detail,
        message: errorData.message || "Виявлено конфлікт.",
      };
    }
  } catch (error) {
    console.error("Не вдалося надіслати підтвердження електронної пошти:", error);
    return {
      success: false,
      message: "Сталася помилка під час надсилання підтвердження електронної пошти.",
    };
  }
};

const fetchIdentitiesCreate = async ({ address,
  birthday,
  city,
  country,
  user,
  zipCode }) => {
  const endpoint = "/identities/create";
  const body = {
    address: address,
    birthday: birthday,
    city: city,
    country: country,
    user: user,
    zip_code: zipCode,
  };
  const token = getTokenFromCookies();

  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token && { 'Authorization': `Bearer ${token}` }),
      },
      body: JSON.stringify(body),
    });
    if (response.ok) {
      const data = await response.json();
      return {
        success: true,
        userData: {
          ...data,
        },
        massage: "Account created successfully.",
      };
    } else {
      const errorData = await response.json();
      console.log(errorData, response.status);
      return {
        success: false,
        status: response.status,
        error: errorData.detail,
        message: errorData.message || "Conflict detected.",
      };
    }
  }
  catch (error) {
    console.error("Failed to send email verification:", error);
    return {
      success: false,
      message: "An error occurred while sending email verification.",
    };
  }
};

// Function to send email verification
const sendEmailVerification = async (email) => {
  const endpoint = "/verification/email/send";
  const data = {
    email: email.toLowerCase(),
  };
  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        message: "Email verification initiated successfully.",
      };
    } else {
      const errorData = await response.json();
      console.log(errorData, response.status);
      return {
        success: false,
        status: response.status,
        message: errorData.message || "Conflict detected.",
      };
    }
  } catch (error) {
    console.error("Failed to send email verification:", error);
    return {
      success: false,
      message: "An error occurred while sending email verification.",
    };
  }
};

const sendPhoneVerification = async (phone) => {
  const endpoint = "/verification/phone/send";
  const data = {
    phone: `+${convertPhoneNumber(phone)}`,
  };
  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        message: "Phone verification initiated successfully.",
      };
    } else {
      const errorData = await response.json();
      console.log(errorData, response.status);
      return {
        success: false,
        status: response.status,
        message: errorData.message || "Conflict detected.",
      };
    }
  } catch (error) {
    console.error("Failed to send phone verification:", error);
    return {
      success: false,
      message: "An error occurred while sending phone verification.",
    };
  }
}

const fetchDeleteUser = async ({ id, password }) => {
  const endpoint = `/users/${id}/delete`;
  const data = {
    password: password,
  };
  try {
    const response = await fetch(url + endpoint, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        message: "Email verification initiated successfully.",
      };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorData.message || "Conflict detected.",
      };
    }
  } catch (error) {
    console.error("Failed to send email verification:", error);
    return {
      success: false,
      message: "An error occurred while sending email verification.",
    };
  }
};

const fetchLogout = async () => {
  const endpoint = "/users/log-out";
  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      credentials: "include",
    });
    if (response.ok) {
      deleteCookie("img");
      deleteCookie("ons");
      deleteCookie("pem");
      return {
        success: true,
        status: response.status,
        userData: {
          fname: "exemple",
          lname: "exemple",
          avatar: "",
          phone: "",
          email: "exemple@exemple.ex",
          isAuth: false,
        },
        message: "Вихід успішний.",
      };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorData.message || "Виявлено конфлікт.",
      };
    }
  } catch (error) {
    console.error("Не вдалося надіслати підтвердження електронної пошти:", error);
    return {
      success: false,
      message: "Сталася помилка під час надсилання підтвердження електронної пошти.",
    };
  }
};

const fetchForgotPassword = async (email) => {
  const endpoint = "/users/forgot";
  const data = {
    email: email.toLowerCase(),
  };
  try {
    const response = await fetch(url + endpoint, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        message: "Email verification initiated successfully.",
      };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorData.message || "Conflict detected.",
      };
    }
  } catch (error) {
    console.error("Failed to send email verification:", error);
    return {
      success: false,
      message: "An error occurred while sending email verification.",
    };
  }
};

const fetchForgotNew = async (newPassword, tk) => {
  const endpoint = "/users/forgot/update-password";
  const data = {
    new_password: newPassword,
    token: tk,
  };
  try {
    const response = await fetch(url + endpoint, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        status: response.status,
        message: "Password updated successfully.",
      };
    } else {
      const errorData = await response.json();
      return {
        success: false,
        status: response.status,
        message: errorData.message || "Conflict detected.",
      };
    }
  } catch (error) {
    console.error("Failed to send email verification:", error);
    return {
      success: false,
      message: "An error occurred while sending email verification.",
    };
  }
};

export {
  fetchLogin,
  fetchCreate,
  sendEmailVerification,
  fetchDeleteUser,
  fetchLogout,
  fetchForgotPassword,
  fetchForgotNew,
  fetch2fa,
  sendPhoneVerification,
  fetchIdentitiesCreate
};
